import { path } from "ramda";

export const logsSelector = path(["logs", "data"]);

export const logsFiltersSelector = path(["logs", "filters"]);

export const logsPageInfoSelector = path(["logs", "pageInfo"]);

export const logsIsLoadingSelector = path(["logs", "isLoading"]);

export const logsNoEntriesMessage = path(["logs", "noEntriesMessage"]);

export const exportLogsCsvLoading = path(["exportLogsCsv", "isLoading"]);

export const exportLogsCsvData = path(["exportLogsCsv", "data"]);



// WEBPACK FOOTER //
// ./src/features/log/selectors/index.js